export const iconFontAwesomeTextformattingStrikethrough = (
	<i className="fa-solid fa-strikethrough"></i>
);
